(function(){
  var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var scrollBehavior = prefersReducedMotion ? 'auto' : 'smooth';
  function init(root){
    var track = root.querySelector('[data-track]');
    var step = function(){ var it = track.querySelector(':scope > *'); return it ? it.getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap || 0) : 300; };
    root.querySelectorAll('[data-prev]').forEach(function(b){ b.addEventListener('click', function(){ track.scrollBy({ left: -step(), behavior: scrollBehavior }); }); });
    root.querySelectorAll('[data-next]').forEach(function(b){ b.addEventListener('click', function(){ track.scrollBy({ left: step(), behavior: scrollBehavior }); }); });
  }
  document.querySelectorAll('[data-carousel]').forEach(init);
})();
